import { Form, Input, Select, message } from "antd";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchRpmDevicesList } from "../../../../Redux/actions/rpmActions";

function DeviceFilter({ handleClose, setDeviceFiltered, setCurrentPage }) {
  const formRef = useRef();
  const dispatch = useDispatch();

  const handleDeviceFilter = () => {
    const values = formRef.current?.getFieldValue?.();
    if (!values) return;

    const { code, name, status } = values;

    if (!code && !name && (status === undefined || status === null)) {
      message.error("Enter any fields to filter the devices.");
      return;
    }

    const payload = {};
    if (code) payload.code = code;
    if (name) payload.name = name;
    if (status !== undefined && status !== null) payload.status = status;

    dispatch(fetchRpmDevicesList(payload));
    setCurrentPage(1);
    setDeviceFiltered(true);
    handleClose();
  };

  return (
    <>
      <Form layout="vertical" ref={formRef}>
        <div className="grid grid-cols-1 items-center justify-center">
          <Form.Item label="Code" name="code">
            <Input placeholder="Enter" />
          </Form.Item>
          <Form.Item label="Name" name="name">
            <Input placeholder="Enter" />
          </Form.Item>
          <Form.Item label="Status" name="status">
            <Select
              allowClear
              placeholder="Select"
              options={[
                { value: 1, label: "Active" },
                { value: 0, label: "Inactive" },
              ]}
            />
          </Form.Item>
        </div>
      </Form>
      <div className="flex items-center w-full justify-end my-5">
        <button
          onClick={handleClose}
          className="border rounded bg-white text-sm px-6 py-1.5"
        >
          Cancel
        </button>
        <button
          onClick={handleDeviceFilter}
          className="bg-brand-primaryColor border rounded px-5 py-1.5 text-white text-sm ml-3"
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default DeviceFilter;
